import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import btu_logo from '@/assets/images/logo.svg';

const MimFailure = () => {
	const [ errorComment, setErrorComment ] = useState('');
	const { hash: locationHash } = useLocation();

	useEffect(() => {
		if (!locationHash) return;
		const [ err, errorType ] = locationHash.split('.');
		if (err !== '#error') return;
		switch (errorType) {
			case ('invalidProvider'):
				setErrorComment('Nieobsługiwany dostawca tożsamości.');
				break;
			case ('inconsistentEmails'):
				setErrorComment('Twoje konto lokalne ma inny adres email niż ten zdefiniowany w MIMie.');
				break;
			case ('emailAlreadyExists'):
				setErrorComment('Email zdefiniowany w MIMie już występuje w systemie dla innego użytkownika.');
				break;
			case ('roleLimitExceeded'):
				setErrorComment('Limit użytkowników dla tej roli został przekroczony.');
				break;
			default:
				setErrorComment('Nieznany błąd. Spróbuj jeszcze raz.');
				break;
		}
	}, [ locationHash ]);

	return (
		<main className='error__main'>
			<div className='error__container'>
				<img
					src={ btu_logo }
					alt='logo btu'
					className='error__logo'
				/>
				<p><strong>Wystąpił błąd logowania do MIM</strong></p>
				<p>{errorComment}</p>
			</div>
		</main>
	);
};
export default MimFailure;